<template>
  <div class="alvaro-validate">
    <AlvaroValidateHeader />
    <Spinner v-if="loading" />
    <div
      v-else-if="htmlFromApi"
      class="alvaro-validate__html-container"
      v-html="htmlFromApi"
    />
    <InputToken v-else />
  </div>
</template>

<script>
import AlvaroValidateHeader from './components/AlvaroValidateHeader.vue'
import InputToken from './components/InputToken.vue'
import ResultsPDFService from '@/api/resultsPDF'
import Spinner from '@/components/common/Spinner'
import notify from '@/api/notification'

export default {
  name: 'AlvaroValidate',
  components: {
    AlvaroValidateHeader,
    InputToken,
    Spinner,
  },
  data() {
    return {
      loading: false,
      htmlFromApi: null,
    }
  },
  watch: {
    $route(to, from) {
      if (to.params.id && to.params.id !== from.params.id) {
        this.fetchToken()
      } else {
        this.htmlFromApi = null
      }
    },
  },
  mounted() {
    this.fetchToken()
  },
  methods: {
    fetchToken() {
      const tokenId = this.$route.params.id
      const recaptchaToken = this.$route.query.recaptcha

      if (tokenId) {
        this.loading = true

        ResultsPDFService.validateResults(tokenId, recaptchaToken)
          .then(response => {
            this.htmlFromApi = null
            this.loading = false
            this.htmlFromApi = response.data

            if (this.htmlFromApi) {
              notify({
                title: 'SUCESSO!',
                message: 'Laudo gerado com sucesso.',
              })
            } else {
              notify({
                title: 'AVISO:',
                message: 'Erro ao gerar o Laudo. Verifique o Token informado.',
              })
            }
          })
          .catch(() => {
            this.loading = false
            notify({
              title: 'AVISO:',
              message: 'Erro ao gerar o Laudo. Verifique o Token informado.',
            })
          })
      }
    },
  },
}
</script>

<style lang="scss">
.alvaro-validate {
  &__html-container {
    padding-top: 100px;
    width: 100%;
    height: 100vh;
  }
}

.valida {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  font-family: 'Exo 2', sans-serif !important;
  height: 100vh;
  overflow: auto;

  > div {
    width: 90%;
    max-width: 1144px;
    text-align: center;
  }
}
</style>
